export default __webpack_public_path__ + "static/media/Ballroll_00184.3558626c.png";